import { SupplierSubscriptionPlan } from '../../../types/SupplierGroupSubscriptionMessage';
import { Button } from '../../cdl/Button/Button';
import { IconButton } from '../../cdl/IconButton/IconButton';
import { Text } from '../../cdl/Text/Text';
import { TextButton } from '../../common/buttons/TextButton';
import { translate } from '../../common/helpers/translate.helper';
import { Characters } from '../../common/helpers/unicode.helper';
import { useLocalStorageState } from '../../common/hooks/useLocalStorageState';
import { useRole } from '../../common/hooks/useRole';
import { IconCircleArrowUp } from '../../common/icons/cdl/CircleArrowUp';
import { IconX } from '../../common/icons/cdl/X';
import { Box } from '../../common/ui/Box';
import { useSupplierSubscriptionPlanPromotion } from '../useSupplierSubscriptionPlanPromotion';
import { useSupplierSubscriptionPlans } from '../useSupplierSubscriptionPlans';

export const SupplierProfessionalPromotionBanner = () => {
    const { canViewPlans, isFeeEnforced, currentPlan, openPlans } = useSupplierSubscriptionPlans();
    const role = useRole();
    const [dismissed, setDismissed] = useLocalStorageState(
        `supplier-plans-banner-dismissed-${role.group?.id ?? ''}`,
        false
    );
    const enabled = canViewPlans && currentPlan === SupplierSubscriptionPlan.BASIC && !dismissed && !isFeeEnforced;
    const promotion = useSupplierSubscriptionPlanPromotion(enabled);
    if (!enabled) {
        return null;
    }

    return (
        <Box
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={8}
            width="100%"
            padding={12}
            borderRadius={8}
            backgroundColor="accent.background"
        >
            <IconCircleArrowUp width={24} height={24} />
            <Box display="flex" flexDirection="column" gap={4} width="100%">
                <Text variant="subtitle2" paddingX={16} textAlign="center">
                    {promotion.heading}
                </Text>
                <Text variant="extraSmall" color="foreground.muted" textAlign="center">
                    {promotion.description}
                </Text>
            </Box>
            <Button type="button" size="small" emphasis="high" width="100%" onClick={openPlans}>
                {translate('supplierSubscriptionPlans.viewPlans')}
            </Button>
            <Text variant="extraSmall" color="foreground.muted" textAlign="center">
                {translate('supplierSubscriptionPlans.or')}
                {Characters.NO_BREAK_SPACE}
                <TextButton disabled>
                    <Text variant="extraSmall">{translate('supplierSubscriptionPlans.contactSalesLink')}</Text>
                </TextButton>
            </Text>
            <Box position="absolute" top={8} right={8}>
                <IconButton
                    Icon={IconX}
                    size="small"
                    emphasis="transparent"
                    aria-label={translate('supplierSubscriptionPlans.dismissBanner')}
                    onClick={() => setDismissed(true)}
                />
            </Box>
        </Box>
    );
};
